module.exports = __webpack_public_path__ + "static/img/h2.300e6cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hor/h2.jpg
// module id = klcC
// module chunks = 1